import { withMetadata } from '../metadata'
import { parsePhoneNumberFromString as _parsePhoneNumberFromString } from '../../core/index'

export function parsePhoneNumberFromString() {
	return withMetadata(_parsePhoneNumberFromString, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/libphonenumber-js/min/exports/parsePhoneNumberFromString.js
// module id = 623
// module chunks = 0